import Big from 'big.js';

export default class MathUtils {
  constructor(value) {
    this.big = new Big(value || 0);
  }

  add(value) {
    this.big = this.big.plus(value || 0);
    return this;
  }

  subtract(value) {
    this.big = this.big.minus(value || 0);
    return this;
  }

  multiply(value) {
    this.big = this.big.times(value || 0);
    return this;
  }

  divide(value) {
    this.big = this.big.div(value || 0);
    return this;
  }

  toNumber() {
    return this.big.toNumber();
  }

  round(precision) {
    this.big = this.big.round(precision);

    return this;
  }
}
